export const REQUEST_FORM_FILE = 'file';
